export const bogStatusQuery = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'BestOddsGuaranteedStatusQuery',
      },
      variableDefinitions: [],
      directives: [],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bogStatus',
            },
            arguments: [],
            directives: [],
          },
        ],
      },
    },
  ],
  loc: {
    start: 0,
    end: 46,
    source: {
      body: 'query BestOddsGuaranteedStatusQuery{bogStatus}',
      name: 'GraphQL request',
      locationOffset: {
        line: 1,
        column: 1,
      },
    },
  },
};

export const bogOptInMutation = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'BestOddsGuaranteedOptInMutation',
      },
      variableDefinitions: [],
      directives: [],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bogOptIn',
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'result',
                  },
                  arguments: [],
                  directives: [],
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'error',
                  },
                  arguments: [],
                  directives: [],
                },
              ],
            },
          },
        ],
      },
    },
  ],
  loc: {
    start: 0,
    end: 64,
    source: {
      body: 'mutation BestOddsGuaranteedOptInMutation{bogOptIn{result error}}',
      name: 'GraphQL request',
      locationOffset: {
        line: 1,
        column: 1,
      },
    },
  },
};
